import { gql } from '@apollo/client';

export const UPSERT_CASE_MANAGEMENT_ACTIVITY = gql`
  mutation upsertCaseManagementActivity($input: UpsertCaseManagementActivityInput!) {
    caseManagementActivity: upsertCaseManagementActivity(input: $input) {
      id
      examinationCardCategories {
        id
        name
      }
      examinationCardServices {
        id
        name
      }
      servicesCardCategories {
        id
        name
      }
      servicesCardServices {
        id
        name
      }
      diagnosisCardCategories {
        id
        name
      }
      diagnosisCardServices {
        id
        name
      }
      assessmentCardCategories {
        id
        name
      }
      assessmentCardServices {
        id
        name
      }
      casePlanCardCategories {
        id
        name
      }
      casePlanCardServices {
        id
        name
      }
      hiddenFields
    }
  }
`;
